import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/** 旧「文件夹详情」路由重定向到共享文献页，并用筛选框选中该文件夹 */
const SharedFolderDetail: React.FC = () => {
  const { folderId } = useParams<{ folderId: string }>();
  if (!folderId) {
    return <Navigate to="/literature/shared" replace />;
  }
  return <Navigate to={`/literature/shared?folder=${encodeURIComponent(folderId)}`} replace />;
};

export default SharedFolderDetail;
